import React from 'react';
import { css } from '@bd/bdui-styles/emotion';
import { ToggleElement } from '@bd/bdcore-utilities';
import Search from '../Search';
import { colors } from '../../styles';

const styles = css`
  display: none;
  @media (min-width: 992px) {
    display: inline-block;
    position: relative;
    padding: 20px 15px;
    z-index: 3;
    padding: 0 20px 0 10px;
  }
  .Toggle_button {
    line-height: 1;
    display: inline-block;
    vertical-align: middle;
  }
  .HeaderSearch_button {
    width: 30px;
    height: 30px;
    border: 0;
    background-color: transparent;
    background-image: url('/images/icon-search-white.svg');
    background-position: center 5px;
    background-repeat: no-repeat;
    background-size: auto 20px;
    border-radius: 3px;
  }
  .Search_results {
    width: 100%;
    background-color: ${colors.brand2};
    padding: 15px;
    position: fixed;
    top: 70px;
    left: 0;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,.2);
    @media (min-width: 992px) {
      position: relative;
      display: inline-block;
      width: 350px;
      top: auto;
      left: auto;
      padding: 0;
      background-color: none;
      animation: search-grow .3s 1;
      margin: 0 0 0 10px;
    }
    input {
      width: 100%;
      padding: 8px 20px;
      animation: input-grow .3s 1;
      border: 0;
      outline: 0;
      &:focus {
        outline: 0;
      }
    }
  }
  .Search_resultsList {
    list-style: none;
    margin: 10px 0 0 0;
    padding: 0;
    height: 200px;
    overflow-y: scroll;
    background-color: ${colors.white};
    @media (min-width: 992px) {
      position: absolute;
      top: 32px;
      left: 0;
      width: 350px;
    }
  }
  .Search_resultsLink {
    display: block;
    padding: 8px 10px;
    font-size: 14px;
    line-height: 1.1;
    color: ${colors.body};
    &:hover {
      background-color: ${colors.neutral};
      color: ${colors.brand1};
    }
  }
  .Search_resultsNone {
    padding: 5px 10px;
  }
  @keyframes search-grow {
   0% {width: 0;}
   100% {width: 350px;}
  }
  @keyframes input-grow {
   0% {padding: 8px 0;}
   100% {padding: 8px 20px;}
  }
`;

function SearchToggle() {
  return (
    <div className={styles}>
      <ToggleElement
        button={<button className="HeaderSearch_button"><span className="sr-only sr-only-focusable">Search</span></button>}
      >
        <Search searchIsFocusedOnLoad />
      </ToggleElement>
    </div>
  );
}

export default SearchToggle;



// WEBPACK FOOTER //
// ./src/components/Header/SearchToggle.js